import { render, staticRenderFns } from "./viewGroup.vue?vue&type=template&id=9166b5b4&scoped=true"
import script from "./viewGroup.vue?vue&type=script&lang=js"
export * from "./viewGroup.vue?vue&type=script&lang=js"
import style0 from "./viewGroup.vue?vue&type=style&index=0&id=9166b5b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9166b5b4",
  null
  
)

export default component.exports